import { useEffect, useState } from 'react'

import { helpCenter } from 'lib/help-center'
import { FeatureFlagsStore } from 'stores'

export const HelpCenterHandler = () => {
  const isZaiChatEnabled = FeatureFlagsStore.isFeatureFlagEnabled('isZaiChatEnabled')

  const [isIntercomBooted, setIsIntercomBooted] = useState(helpCenter.booted)

  useEffect(() => {
    if (!isZaiChatEnabled) return

    if (isIntercomBooted) {
      helpCenter.init()
      return
    }

    const interval = setInterval(() => {
      if (helpCenter.booted) {
        setIsIntercomBooted(true)
      }
    }, 500)

    return () => clearInterval(interval)
  }, [isIntercomBooted, isZaiChatEnabled])

  return null
}
